import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllTargets = createAsyncThunk(
  "TargetSet/FindAllTargetSet",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TargetSet/FindAllTargetSet`,
        formdata
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Targets:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createTarget = createAsyncThunk(
  "TargetSet/InsertTargetSet",
  async (TargetData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TargetSet/InsertTargetSet`,
        TargetData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Target:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTarget = createAsyncThunk(
  "TargetSet/UpdateTargetSet",
  async (TargetData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TargetSet/UpdateTargetSet`,
        TargetData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating target:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTarget = createAsyncThunk(
  "TargetSet/DeleteTargetSet",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TargetSet/DeleteTargetSet`,
        { target_set_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting target:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTargetByID = createAsyncThunk(
  "TargetSet/FindByIDTargetSet",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TargetSet/FindByIDTargetSet`,
        formData
      );
      const result = response.data?.Data as any;
      return {
        id: result?.id,
        target_set_guid: result?.target_set_guid,
        from_date: result?.from_date
          ? moment(result?.from_date, "YYYY-MM-DD").toDate()
          : "",
        to_date: result?.to_date
          ? moment(result?.to_date, "YYYY-MM-DD").toDate()
          : "",
        sr_id: result?.sr_id,
        basic_per: result.basic_per,
        target_per: result.target_per,
        target: result.target,
        distributor_id: result.distributor_id,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching target:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const compareTargetView = createAsyncThunk(
  "Target/FindAllTargetview",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Target/FindAllTargetview`,
        formdata
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Targets:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
